<template>
  <div class="error-page-container">
    <div class="error-card">
      <div class="code-badge">404</div>
      <div class="error-icon">
        <i class="el-icon-warning-outline"></i>
      </div>
      <h2 class="error-title">抱歉，您访问的页面不存在或已迁移</h2>
      <p class="error-desc">
        请核对网址是否输入正确，或该物资采购页面可能已被下架或调整了权限。
      </p>
      <div class="action-buttons">
        <el-button type="primary" icon="el-icon-s-home" @click="goHome">
          返回商城主页
        </el-button>
        <el-button icon="el-icon-back" @click="goBack">
          返回上一页
        </el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ErrorPage',
  methods: {
    goHome() {
      this.$router.push('/');
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped lang="less">
@import "../assets/css/var.less";

.error-page-container {
  width: 100vw;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f8fafc;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif;

  .error-card {
    text-align: center;
    background: #ffffff;
    border: 1px solid #e2e8f0;
    border-radius: 16px;
    padding: 60px 48px;
    max-width: 520px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.05);

    .code-badge {
      display: inline-block;
      font-size: 64px;
      font-weight: 900;
      color: @brandPrimary;
      line-height: 1;
      letter-spacing: -2px;
      margin-bottom: 16px;
    }

    .error-icon {
      font-size: 36px;
      color: #94a3b8;
      margin-bottom: 12px;
    }

    .error-title {
      font-size: 18px;
      font-weight: 700;
      color: #0f172a;
      margin: 0 0 10px;
    }

    .error-desc {
      font-size: 13px;
      line-height: 1.6;
      color: #64748b;
      margin: 0 0 32px;
    }

    .action-buttons {
      display: flex;
      justify-content: center;
      gap: 16px;

      .el-button--primary {
        background-color: @brandPrimary;
        border-color: @brandPrimary;
        font-weight: 600;

        &:hover {
          background-color: @brandSecondary;
          border-color: @brandSecondary;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/pages/ErrorPage.vue